'use client'

import { useRouter } from 'next/navigation'
import { Button } from '@ui/base/button'
import { RotateCwIcon } from 'lucide-react'

export const RetryButton = () => {
  const router = useRouter()

  return (
    <Button onClick={() => router.refresh()}>
      <RotateCwIcon className="size-4" aria-hidden />
      Попробовать снова
    </Button>
  )
}
